<div
    class="bg-card rounded-2xl p-4 shadow-sm cursor-pointer hover:shadow-md transition-shadow mb-4 border border-gray-100 dark:border-gray-800"
    (click)="navigateToDetails()"
>
    <!-- Header -->
    <div class="flex items-center justify-between mb-1">
        <h3 class="text-foreground text-sm font-semibold">Assessment Score</h3>
        <div class="w-7 h-7 rounded-full border border-[#F5A623] flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                 stroke="#F5A623" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <line x1="7" y1="17" x2="17" y2="7"></line>
                <polyline points="7 7 17 7 17 17"></polyline>
            </svg>
        </div>
    </div>

    <!-- Gauge Section -->
    <div class="flex flex-col items-center justify-center">
        <!--
          Arc:   cx=50, cy=58, r=42
          Start: (8, 58)  End: (92, 58)
          Ticks: r_inner=46.5, r_outer=51.5  → 4.5px gap from arc outer edge (arc stroke-width=8, so outer edge = r+4 = 46)
          viewBox: 0 0 100 68  (58 + 10px bottom padding)
        -->
        <svg viewBox="0 0 100 68" class="w-full max-w-[220px]">
            <defs>
                <linearGradient id="gaugeGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%"   stop-color="#EF4444"/>
                    <stop offset="30%"  stop-color="#F97316"/>
                    <stop offset="58%"  stop-color="#EAB308"/>
                    <stop offset="100%" stop-color="#22C55E"/>
                </linearGradient>
            </defs>

            <!--
              Tick coords: point1 = r_inner, point2 = r_outer from center (50,58)
              angle in degrees, converted: x = 50 + r*cos(deg), y = 58 - r*sin(deg)
              r_inner=46.5, r_outer=51.5
              180°: cos=-1, sin=0   →  inner(3.5, 58)   outer(-1.5, 58)  [clamp to 0]
              162°: cos=-.951,sin=.309 → inner(5.8,43.6) outer(1.3,42.1)
              144°: cos=-.809,sin=.588 → inner(12.4,30.6) outer(8.0,28.3)
              126°: cos=-.588,sin=.809 → inner(22.7,20.5) outer(19.7,17.8)
              108°: cos=-.309,sin=.951 → inner(35.6,13.7) outer(34.1,9.6)
               90°: cos=0,   sin=1    → inner(50,11.5)   outer(50,6.5)
               72°: cos=.309,sin=.951 → inner(64.4,13.7) outer(65.9,9.6)
               54°: cos=.588,sin=.809 → inner(77.3,20.5) outer(80.3,17.8)
               36°: cos=.809,sin=.588 → inner(87.6,30.6) outer(92.0,28.3)
               18°: cos=.951,sin=.309 → inner(94.2,43.6) outer(98.7,42.1)
                0°: cos=1,   sin=0    → inner(96.5,58)   outer(101.5,58) [clamp to 100]
            -->
            <g stroke-linecap="round" stroke-width="1.3">
              <line x1="3.5"  y1="58.0" x2="0.0"  y2="58.0" stroke="#EF4444"/>
              <line x1="5.8"  y1="43.6" x2="1.3"  y2="42.1" stroke="#EF4444"/>
              <line x1="12.4" y1="30.6" x2="8.0"  y2="28.3" stroke="#F97316"/>
              <line x1="22.7" y1="20.5" x2="19.7" y2="17.8" stroke="#F97316"/>
              <line x1="35.6" y1="13.7" x2="34.1" y2="9.6"  stroke="#EAB308"/>
              <line x1="50.0" y1="11.5" x2="50.0" y2="6.5"  stroke="#EAB308"/>
              <line x1="64.4" y1="13.7" x2="65.9" y2="9.6"  stroke="#84CC16"/>
              <line x1="77.3" y1="20.5" x2="80.3" y2="17.8" stroke="#84CC16"/>
              <line x1="87.6" y1="30.6" x2="92.0" y2="28.3" stroke="#22C55E"/>
              <line x1="94.2" y1="43.6" x2="98.7" y2="42.1" stroke="#22C55E"/>
              <line x1="96.5" y1="58.0" x2="100"  y2="58.0" stroke="#22C55E"/>
            </g>

            <!-- Background arc -->
            <path
                d="M 8,58 A 42,42 0 0,1 92,58"
                fill="none"
                stroke="#E5E7EB"
                class="dark:stroke-gray-700"
                stroke-width="8"
                stroke-linecap="round"
            />

            <!-- Gradient progress arc -->
            <path
                d="M 8,58 A 42,42 0 0,1 92,58"
                fill="none"
                stroke="url(#gaugeGrad)"
                stroke-width="8"
                stroke-linecap="round"
                class="gauge-path"
                [style.stroke-dasharray]="strokeDashArray"
            />
        </svg>

        <!-- Score text — sits directly under the SVG, no negative margin needed -->
        <div class="flex flex-col items-center text-center -mt-20">
            <span class="text-3xl font-extrabold text-[#101828] dark:text-gray-100">
                {{ (score | number:'1.0-0') || 0 }}
            </span>
            <span class="text-[11px] text-[#667085] dark:text-gray-400 font-medium">out of 100</span>
        </div>
    </div>

    <!-- Footer Text -->
    <div class="mt-4 text-center">
        <p class="text-[11px] text-[#667085] dark:text-gray-400 leading-relaxed px-2">
            Calculated from your nutrition, hydration, and health data.
        </p>
    </div>
</div>
